import { render, staticRenderFns } from "./ExtendSessionMessage.vue?vue&type=template&id=060bf358"
import script from "./ExtendSessionMessage.vue?vue&type=script&lang=js"
export * from "./ExtendSessionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports